<template>
  <div class="telemetry-car-speed-parts">
    <p class="telemetry-car-speed-parts__data">{{ Math.floor(viewValue) }}</p>
    <p class="telemetry-car-speed-parts__label"><span>km/h</span></p>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー 車速値セクションのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryCarSpeedParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
    },
    /**
     * 表示fpsと受信データ間隔の差分ms
     */
    diffMs: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { setupIntermediateValue } = useTelemetrySectionUtil()
    const { value } = toRefs(props)
    const viewValue = setupIntermediateValue(value, props.diffMs)
    return {
      viewValue,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.telemetry-car-speed-parts {
  position: absolute;
  left: calc(#{min(4.2667vw, 1.333em)} + 1.6667em);
  top: calc(#{min(4.2667vw, 1.333em)} + 5.8em);
  width: 25.25em;
  text-align: center;

  &__label {
    font-size: 1em;
    color: $white;
    letter-spacing: 0.04em;
    padding-left: 0.04em;
    opacity: 0.5;

    span {
      font-size: max(1em, 8px);
    }
  }

  &__data {
    font-size: 3.333em;
    color: $white;
    font-weight: 300;
    line-height: 1;
    letter-spacing: 0.04em;
    padding-left: 0.04em;
    font-family: $fontTelemetrySpeedGear;
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-car-speed-parts {
      top: 6.6em;
    }
  }
}
</style>
